import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "mobileButton", "collapseButton", "overlay"]
  
  connect() {
    // Check localStorage for collapsed state
    const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true'
    if (isCollapsed) {
      this.collapse()
    }
  }

  toggleMobile() {
    this.sidebarTarget.classList.toggle('-translate-x-full')
    this.sidebarTarget.classList.toggle('translate-x-0')
    
    // Toggle overlay visibility
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle('hidden')
    }
  }

  toggleCollapse() {
    if (this.sidebarTarget.classList.contains('w-64')) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  collapse() {
    this.sidebarTarget.classList.remove('w-64')
    this.sidebarTarget.classList.add('w-16')
    this.collapseButtonTarget.classList.add('rotate-180')
    localStorage.setItem('sidebarCollapsed', 'true')
  }

  expand() {
    this.sidebarTarget.classList.remove('w-16')
    this.sidebarTarget.classList.add('w-64')
    this.collapseButtonTarget.classList.remove('rotate-180')
    localStorage.setItem('sidebarCollapsed', 'false')
  }
} 